/**
 * Holds scope of today page
 */

import { defineStore } from "pinia";
import {SrcType} from "@t/meta/SourceType.ts";
import { ref, type InjectionKey, inject } from "vue";
import {env} from "@fd/Environment.ts";
import {AppContextMap, clearMap, cloneMap, injectContext} from "@t/fd/AppContext.ts";
import {DEBUGGER} from "@/intouch";


export type CalendarType = "user" | "group" | "shared";

/** Source of calendar data */
export interface CalendarSource {
	type: CalendarType;
	id: string | number;
	name?: string;

	/** SrcType of newly created calendar entries (defaults to EVENT(2)) */
	createSrcType?: number;
	createSrcSubType?: number;
}

export const calendarSourceKey = Symbol() as InjectionKey<CalendarSource>;


export const useTodayStore = defineStore('today', () =>{

	const ctx = injectContext();

	/** Calendar context */
	const type = ref<CalendarType>("user");
	const id = ref<number|string>(env.user.id);
	const name = ref<string>(env.user.name);
	const createSrcType = ref<number>(SrcType.EVENT);
	const createSrcSubType = ref<number>(0);
	const createContext = ref<AppContextMap>(cloneMap(ctx.value));

	const csInit = inject(calendarSourceKey, null);
	if (csInit) {
		if (csInit.type) type.value = csInit.type;
		if (csInit.id) id.value = csInit.id;
		if (csInit.name) name.value = csInit.name;
		if (csInit.createSrcType) {
			createSrcType.value = csInit.createSrcType;
			if (csInit.createSrcSubType) createSrcSubType.value = csInit.createSrcSubType;
			else createSrcSubType.value = 0;
		}
	}

	function clearCreateContext() {
		clearMap(createContext.value);
	}

	return { type, id, name, createSrcType, createSrcSubType, createContext, clearCreateContext };
});
